import { format } from 'date-fns/format';
import { formatDistanceToNow } from 'date-fns/formatDistanceToNow';
import { isFuture } from 'date-fns/isFuture';
import { safeExecute } from './safeExecute';

export const timeDifference = (time) => formatDistanceToNow(new Date(time), { addSuffix: true });
export const dayOfWeek = (time) => format(new Date(time), 'iiii');
export const monthDayYear = (time) =>
  safeExecute(() => format(new Date(time), 'MMM dd, yyyy'), `Error formatting date, time: ${time}`);
export const isFutureDate = (time) => isFuture(new Date(time));
